import React from 'react';

import sleepyLogo from '@/assets/sleepy-logo.png';
import { siteBrandLogo } from '@/services/siteBoot';

/**
 * The logo inside the loading spinner: the site's own nav logo while one of its pages is on screen (so an org's
 * homepage is branded end to end), else the Sleepy logo. A logo that fails to load falls back to the Sleepy one.
 */
export const SplashLogo: React.FC = () => (
  <img
    className="boot-splash__logo"
    src={siteBrandLogo() || sleepyLogo}
    alt=""
    onError={(e) => { if (e.currentTarget.src !== new URL(sleepyLogo, document.baseURI).href) e.currentTarget.src = sleepyLogo; }}
  />
);

/**
 * The full-page loading screen: a spinner around the logo. Same markup and classes (public/boot-splash.css) as the
 * static splash in index.html and site.html, so the hand-over from those to this is seamless.
 */
export const BootSplash: React.FC = () => (
  <div className="boot-splash" role="status" aria-label="Loading">
    <div className="boot-splash__spinner"><SplashLogo /></div>
  </div>
);
